import styled from 'styled-components'

export const SubHeaderWrapper = styled.div`
	position: fixed;
	top: ${(props) => (props.top ? `${props?.top}` : '91px')};
	left: 0;
	right: 0;
	z-index: 2;
	background: #fff;
	border-bottom: 1px solid #e8e8e8;
	.layout-sub-nav{
		display: flex;
		justify-content: flex-end;
		padding-right: 66px;
		padding-top: 10px;
		padding-bottom: 10px;
	}
`